<template>
  <el-dialog
    title="选择抽奖礼品"
    :visible.sync="addvisible"
    width="70%"
    append-to-body
    @close="closeDialog"
  >
    <div class="innerBody">
      <div class="section-title">已选礼物（可重复添加同一商品）</div>
      <el-table
        v-if="selectedList.length"
        size="small"
        :data="selectedList"
        border
        style="width: 100%; margin-bottom: 16px"
      >
        <el-table-column type="index" label="序号" width="60" />
        <el-table-column prop="id" label="商品ID" width="80" />
        <el-table-column prop="name" label="商品标题" min-width="120" />
        <el-table-column prop="pointsPrice" label="兑换积分" width="100" />
        <el-table-column align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              :disabled="scope.$index === 0"
              @click="moveSelected(scope.$index, -1)"
              >上移</el-button
            >
            <el-button
              type="text"
              size="mini"
              :disabled="scope.$index === selectedList.length - 1"
              @click="moveSelected(scope.$index, 1)"
              >下移</el-button
            >
            <el-button
              type="text"
              size="mini"
              class="btn-danger-text"
              @click="removeSelected(scope.$index)"
              >移除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-empty v-else description="暂未添加礼物，请从下方商品库添加" :image-size="60" />

      <div class="section-title">商品库</div>
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        border
        element-loading-text="拼命加载中"
        style="width: 100%"
      >
        <el-table-column prop="id" label="商品ID" width="80" />
        <el-table-column prop="image" label="商品图片" width="120">
          <template slot-scope="scope">
            <img
              :src="$store.state.fileBaseUrl + scope.row.image"
              alt=""
              style="width: 80px; height: 80px"
            />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商品标题" min-width="120" />
        <el-table-column prop="pointsPrice" label="兑换积分" width="100" />
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="addGood(scope.row)"
              >添加</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div slot="footer" class="dialog-footer">
      <span class="footer-tip">已选 {{ selectedList.length }} 件</span>
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="confirm()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      listData: [],
      pageparm: {
        pageNum: 1,
        pageSize: 100,
        total: 0,
        onSale: "",
      },
      addvisible: false,
      selectedList: [],
    };
  },
  created() {
    this.getdata(this.pageparm);
  },
  methods: {
    cloneGood(row) {
      return {
        id: row.id,
        name: row.name,
        image: row.image,
        pointsPrice: row.pointsPrice,
      };
    },
    addGood(row) {
      this.selectedList.push(this.cloneGood(row));
    },
    removeSelected(index) {
      this.selectedList.splice(index, 1);
    },
    moveSelected(index, delta) {
      const next = index + delta;
      if (next < 0 || next >= this.selectedList.length) return;
      const list = this.selectedList.slice();
      const item = list.splice(index, 1)[0];
      list.splice(next, 0, item);
      this.selectedList = list;
    },
    confirm() {
      this.$emit("confirm", this.selectedList.slice());
      this.addvisible = false;
    },
    init(arr) {
      const source = Array.isArray(arr) ? arr : [];
      this.selectedList = source.map((item) => {
        if (item && typeof item === "object") {
          return this.cloneGood(item);
        }
        return { id: item, name: "商品" + item, pointsPrice: "-" };
      });
      this.addvisible = true;
    },
    closeDialog() {
      this.addvisible = false;
    },
    getdata(parameter) {
      this.loading = true;
      this.$request
        .getGoods(parameter)
        .then((res) => {
          this.loading = false;
          this.listData = res.data.list || [];
          this.pageparm.pageNum = res.data.pageNum;
          this.pageparm.pageSize = res.data.pageSize;
          this.pageparm.total = res.data.total;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}
.footer-tip {
  float: left;
  line-height: 32px;
  color: #909399;
  font-size: 13px;
}
.btn-danger-text {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/views/tasks/gift.vue